import * as React from "react";

import { createSvgIcon } from "@mui/material/utils";

const Achievement8Icon = createSvgIcon(
    <svg
        width="160"
        height="160"
        viewBox="0 0 160 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10 94.7326V26C10 22.6863 12.6863 20 16 20H43.3866C44.4434 20 45.4815 19.7209 46.3958 19.1908L76.5124 1.73197C78.3619 0.659779 80.6422 0.652688 82.4984 1.71335L113.117 19.2095C114.023 19.7275 115.049 20 116.093 20H143C146.314 20 149 22.6863 149 26V94.7326C149 111.552 139.821 127.03 125.062 135.097L82.3777 158.427C80.5844 159.407 78.4156 159.407 76.6223 158.427L33.9378 135.097C19.1794 127.03 10 111.552 10 94.7326Z"
            fill="url(#paint0_linear_5305_1597)"
        />
        <g filter="url(#filter0_i_5305_1597)">
            <path
                d="M23 95.1528V37.25C23 33.9363 25.6863 31.25 29 31.25H50.3598C51.4336 31.25 52.4877 30.9618 53.4121 30.4156L76.5271 16.7567C78.3675 15.6692 80.6476 15.643 82.5125 16.688L107.133 30.4843C108.029 30.9863 109.039 31.25 110.066 31.25H130C133.314 31.25 136 33.9363 136 37.25V95.1528C136 106.856 129.611 117.625 119.341 123.236L82.3764 143.429C80.5838 144.408 78.4162 144.408 76.6236 143.429L39.659 123.236C29.3885 117.625 23 106.856 23 95.1528Z"
                fill="url(#paint1_linear_5305_1597)"
            />
        </g>
        <path
            d="M23 95.1528V37.25C23 33.9363 25.6863 31.25 29 31.25H50.3598C51.4336 31.25 52.4877 30.9618 53.4121 30.4156L76.5271 16.7567C78.3675 15.6692 80.6476 15.643 82.5125 16.688L107.133 30.4843C108.029 30.9863 109.039 31.25 110.066 31.25H130C133.314 31.25 136 33.9363 136 37.25V95.1528C136 106.856 129.611 117.625 119.341 123.236L82.3764 143.429C80.5838 144.408 78.4162 144.408 76.6236 143.429L39.659 123.236C29.3885 117.625 23 106.856 23 95.1528Z"
            stroke="url(#paint2_linear_5305_1597)"
            strokeWidth="3"
        />
        <g filter="url(#filter1_d_5305_1597)">
            <path
                d="M78.2065 43.634C78.9402 42.1475 81.0598 42.1475 81.7935 43.634L85.4125 50.9669C85.7038 51.5572 86.267 51.9664 86.9184 52.061L95.0108 53.2369C96.6512 53.4753 97.3063 55.4912 96.1192 56.6483L90.2635 62.3562C89.7921 62.8157 89.577 63.4777 89.6883 64.1265L91.0707 72.1862C91.3509 73.82 89.636 75.066 88.1688 74.2946L80.9307 70.4893C80.348 70.183 79.652 70.183 79.0693 70.4893L71.8312 74.2946C70.364 75.066 68.6491 73.82 68.9293 72.1862L70.3117 64.1265C70.423 63.4777 70.2079 62.8157 69.7365 62.3562L63.8808 56.6483C62.6937 55.4912 63.3488 53.4753 64.9892 53.2369L73.0816 52.061C73.733 51.9664 74.2962 51.5572 74.5875 50.9669L78.2065 43.634Z"
                fill="#F5E65F"
            />
            <path
                d="M78.8789 43.9658C79.3088 43.0948 80.5004 43.0404 81.0254 43.8027L81.1211 43.9658L84.7402 51.2988C85.1158 52.0598 85.8198 52.6015 86.6445 52.7734L86.8105 52.8037L94.9033 53.9795C95.8642 54.1194 96.284 55.235 95.7217 55.9697L95.5957 56.1113L89.7402 61.8193C89.1326 62.4116 88.8346 63.2485 88.9258 64.0859L88.9492 64.2529L90.3311 72.3135C90.4949 73.2705 89.5639 74.0146 88.6914 73.707L88.5176 73.6309L81.2793 69.8252C80.5283 69.4305 79.6401 69.4055 78.8721 69.751L78.7207 69.8252L71.4824 73.6309C70.6226 74.0829 69.6269 73.4264 69.6504 72.501L69.6689 72.3135L71.0508 64.2529C71.1941 63.4165 70.9431 62.5642 70.377 61.9404L70.2598 61.8193L64.4043 56.1113C63.7088 55.4334 64.025 54.2834 64.9121 54.0195L65.0967 53.9795L73.1895 52.8037C74.0291 52.6817 74.7622 52.1792 75.1807 51.4482L75.2598 51.2988L78.8789 43.9658Z"
                stroke="#E69614"
                strokeWidth="1.5"
            />
        </g>
        <g filter="url(#filter2_d_5305_1597)">
            <path
                d="M78.2065 83.634C78.9402 82.1475 81.0598 82.1475 81.7935 83.634L85.4125 90.9669C85.7038 91.5572 86.267 91.9664 86.9184 92.061L95.0108 93.2369C96.6512 93.4753 97.3063 95.4912 96.1192 96.6483L90.2635 102.356C89.7921 102.816 89.577 103.478 89.6883 104.126L91.0707 112.186C91.3509 113.82 89.636 115.066 88.1688 114.295L80.9307 110.489C80.348 110.183 79.652 110.183 79.0693 110.489L71.8312 114.295C70.364 115.066 68.6491 113.82 68.9293 112.186L70.3117 104.126C70.423 103.478 70.2079 102.816 69.7365 102.356L63.8808 96.6483C62.6937 95.4912 63.3488 93.4753 64.9892 93.2369L73.0816 92.061C73.733 91.9664 74.2962 91.5572 74.5875 90.9669L78.2065 83.634Z"
                fill="#F5E65F"
            />
            <path
                d="M78.8789 83.9658C79.3088 83.0948 80.5004 83.0404 81.0254 83.8027L81.1211 83.9658L84.7402 91.2988C85.1158 92.0598 85.8198 92.6015 86.6445 92.7734L86.8105 92.8037L94.9033 93.9795C95.8642 94.1194 96.284 95.235 95.7217 95.9697L95.5957 96.1113L89.7402 101.819C89.1326 102.412 88.8346 103.249 88.9258 104.086L88.9492 104.253L90.3311 112.313C90.4949 113.27 89.5639 114.015 88.6914 113.707L88.5176 113.631L81.2793 109.825C80.5283 109.431 79.6401 109.406 78.8721 109.751L78.7207 109.825L71.4824 113.631C70.6226 114.083 69.6269 113.426 69.6504 112.501L69.6689 112.313L71.0508 104.253C71.1941 103.417 70.9431 102.564 70.377 101.94L70.2598 101.819L64.4043 96.1113C63.7088 95.4334 64.025 94.2834 64.9121 94.0195L65.0967 93.9795L73.1895 92.8037C74.0291 92.6817 74.7622 92.1792 75.1807 91.4482L75.2598 91.2988L78.8789 83.9658Z"
                stroke="#E69614"
                strokeWidth="1.5"
            />
        </g>
        <defs>
            <filter
                id="filter0_i_5305_1597"
                x="21.5"
                y="14.4223"
                width="120"
                height="135.241"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="4" dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_5305_1597"
                />
            </filter>
            <filter
                id="filter1_d_5305_1597"
                x="58.2747"
                y="36.5191"
                width="45.4507"
                height="44.0096"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="1" />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5305_1597"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5305_1597"
                    result="shape"
                />
            </filter>
            <filter
                id="filter2_d_5305_1597"
                x="58.2747"
                y="76.5191"
                width="45.4507"
                height="44.0096"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="1" />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5305_1597"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5305_1597"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_5305_1597"
                x1="10"
                y1="0"
                x2="168.978"
                y2="141.565"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FBE865" />
                <stop offset="1" stopColor="#F1A718" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_5305_1597"
                x1="23"
                y1="15"
                x2="151.734"
                y2="126.899"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FFE33D" />
                <stop offset="1" stopColor="#E1980D" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_5305_1597"
                x1="136"
                y1="145"
                x2="23"
                y2="15"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E69614" />
                <stop offset="1" stopColor="#E69614" stopOpacity="0" />
            </linearGradient>
        </defs>
    </svg>,
    "Achievement8Icon",
);

export default Achievement8Icon;
